import axios, { InternalAxiosRequestConfig, type AxiosInstance, type AxiosError } from 'axios';
import { useAuthStore } from '@/stores/auth';
import router from '@/router';
import { useToast } from '@/composables/useToast';

const axiosClient: AxiosInstance = axios.create({
    baseURL: String(import.meta.env.VITE_API_URL),
    // baseURL: 'http://travel.localhost.localdomain/index.php/packageBuilder/api_1_0/',
});

axiosClient.interceptors.request.use((config: InternalAxiosRequestConfig) => {
    const authStore = useAuthStore();
    config.headers!.Authorization = `Bearer ${authStore.getJwt}`;
    config.headers!.Accept = 'application/json';
    return config;
});

axiosClient.interceptors.response.use(
    function (response) {
        if (
            response.status === 200 &&
            response.data.status === false &&
            response.data.errorCode === 1007
        ) {
            router.push('/logout');
        }

        return response;
    },
    function (error: AxiosError) {
        if (axios.isCancel(error)) {
            return Promise.reject(error);
        }
        const { show } = useToast();
        const status = error.response?.status;

        if (status === 401) {
            router.push('/logout');
        } else if (status === 500) {
            show('A server error occurred. Please try again later.', 'error');
        } else if (status === 403) {
            show('You do not have permission to perform this action.', 'error');
        } else if (status === 404) {
            show('The requested resource was not found.', 'warning');
        } else if (!error.response) {
            show('No connection to the server. Please check your internet connection.', 'error');
        } else {
            show('An unexpected error occurred. Please try again.', 'error');
        }

        return Promise.reject(error);
    }
);

export default axiosClient;
